(function () {
  const WHOLESALE_TAGS = ['Wholesale', 'wholesale', 'dev-discount-wholesale'];

  function getCustomerTags() {
    const el = document.querySelector('[data-customer-tags]');
    if (!el) return [];
    try {
      return JSON.parse(el.dataset.customerTags).map(t => t.toLowerCase());
    } catch { return []; }
  }

  function isWholesaleBundle(bundle) {
    const tags = bundle.limit_for_customer_tags || [];
    return tags.some(t => WHOLESALE_TAGS.includes(t.toLowerCase()));
  }

  function customerHasTag(customerTags, requiredTags) {
    if (!requiredTags || requiredTags.length === 0) return true;
    return requiredTags.some(t => customerTags.includes(t.toLowerCase()));
  }

  function findBundlesForProduct(productId) {
    if (!window.bndlr || typeof window.bndlr.getBundles !== 'function') return [];
    const bundles = window.bndlr.getBundles();
    if (!Array.isArray(bundles)) return [];

    return bundles.filter(b => {
      if (b.status !== 'enabled') return false;
      if (b.is_quantity_break !== 'true' && b.is_volume_bundle !== 'true') return false;
      if (!b.volume_discounts || b.volume_discounts.length === 0) return false;
      return b.products && b.products[productId];
    });
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = window.Shopify?.locale || 'en';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  // Idempotent DOM mutation helpers. Setting textContent / style.display unconditionally
  // generates DOM mutations even when the value is unchanged (replacing text nodes,
  // rewriting style attributes), which triggers bundler's #cart-drawer MutationObserver
  // and feeds back into bundler:total_cart_values - causing a perpetual no-op loop on
  // carts that only have an order-level discount (e.g. Rewards) and no bundler discount.
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setDisplay(el, display) {
    if (el && el.style.display !== display) el.style.display = display;
  }

  function getSelectedVariantPrice() {
    const checked = document.querySelector('input[name="id"]:checked')
      || document.querySelector('input[name="id"]');
    return checked ? Number(checked.dataset.price) : 0;
  }

  function getSelectedVariantId() {
    const checked = document.querySelector('input[name="id"]:checked')
      || document.querySelector('input[name="id"]');
    return checked ? checked.value : null;
  }

  function findBundleForVariant(bundles, productId, variantId) {
    if (!variantId) return null;
    for (const bundle of bundles) {
      const product = bundle.products?.[productId];
      if (product && product.variants?.[variantId]) return bundle;
    }
    return null;
  }

  function applyDiscount(priceCents, pct) {
    return Math.round(priceCents * (1 - pct / 100));
  }

  function getWholesaleTier(volumeDiscounts) {
    if (!volumeDiscounts || volumeDiscounts.length === 0) return null;
    const tiers = volumeDiscounts.filter(d =>
      d.range_type !== 'range' && Number(d.discount_value) > 0
    );
    if (tiers.length === 0) return null;
    return tiers.sort((a, b) => a.min_items - b.min_items)[0];
  }

  function buildTableHTML(tiers, price) {
    const activeTiers = tiers.filter(d => Number(d.discount_value) > 0);
    if (activeTiers.length === 0) return '';

    let html = '<table><thead><tr><th>Quantity</th><th>Discount</th><th>Price Per Item</th></tr></thead><tbody>';
    for (const tier of activeTiers) {
      const pct = Number(tier.discount_value);
      const discounted = applyDiscount(price, pct);
      html += `<tr data-bundler-discount="${pct}">`;
      html += `<td>${tier.min_items}+</td>`;
      html += `<td>${pct}% off</td>`;
      html += `<td>${formatMoney(discounted)}</td>`;
      html += '</tr>';
    }
    html += '</tbody></table>';
    return html;
  }

  function buildInlineDiscountText(tiers, suffix) {
    const activeTiers = tiers.filter(d => Number(d.discount_value) > 0);
    return activeTiers.map(tier => {
      const pct = Number(tier.discount_value);
      return `<p>${pct}% off - ${tier.min_items}${suffix ? ' ' + suffix : ''}+</p>`;
    }).join('');
  }

  function categorizeBundles(bundles, customerTags) {
    const qb = [];
    const wholesale = [];

    for (const bundle of bundles) {
      if (isWholesaleBundle(bundle)) {
        if (customerHasTag(customerTags, bundle.limit_for_customer_tags)) {
          wholesale.push(bundle);
        }
      } else {
        const tags = bundle.limit_for_customer_tags || [];
        if (tags.length === 0 || customerHasTag(customerTags, tags)) {
          qb.push(bundle);
        }
      }
    }

    const byPriority = (a, b) => (b.priority || 0) - (a.priority || 0);
    qb.sort(byPriority);
    wholesale.sort(byPriority);

    return { qb, wholesale };
  }

  function updateWholesalePriceDisplay(price, wholesaleBundle) {
    if (!wholesaleBundle) return;
    const priceEl = document.querySelector('[product-price]');
    if (!priceEl) return;

    const wholesaleTier = getWholesaleTier(wholesaleBundle.volume_discounts);
    if (!wholesaleTier) return;

    const pct = Number(wholesaleTier.discount_value);
    const wholesalePrice = applyDiscount(price, pct);

    const wholesaleSpan = document.createElement('span');
    wholesaleSpan.textContent = formatMoney(wholesalePrice);

    const retailSpan = document.createElement('span');
    retailSpan.textContent = formatMoney(price);
    retailSpan.className = 'line-through';

    priceEl.replaceChildren(wholesaleSpan, retailSpan);
    priceEl.className = 'row gap-2';

    return wholesaleTier;
  }

  function renderPDP() {
    const el = document.querySelector('[data-bundler-product-id]');
    if (!el) return;
    const productId = el.dataset.bundlerProductId;
    const customerTags = getCustomerTags();
    const bundles = findBundlesForProduct(productId);
    const price = getSelectedVariantPrice();
    const { qb, wholesale } = categorizeBundles(bundles, customerTags);

    let wholesaleHasMoq = false;
    let wholesaleActive = false;
    const wsContainer = document.getElementById('bundler-wholesale');
    const variantId = getSelectedVariantId();
    if (wsContainer && wholesale.length > 0) {
      const best = findBundleForVariant(wholesale, productId, variantId);
      const activeTiers = best ? best.volume_discounts.filter(d => Number(d.discount_value) > 0) : [];

      if (best && activeTiers.length > 0) {
        wholesaleActive = true;
        const appliedTier = updateWholesalePriceDisplay(price, best);
        wsContainer.hidden = false;

        const moq = appliedTier ? appliedTier.min_items : 0;
        wholesaleHasMoq = moq > 1;
        const moqText = wholesaleHasMoq ? `Minimum Order Quantity: ${moq}` : 'No Minimum Order Quantity';
        wsContainer.innerHTML = `<p class="text-secondary">Wholesale Price (${moqText})</p>`;
      } else {
        wsContainer.hidden = true;
        wsContainer.innerHTML = '';
      }
    }

    const showQb = !wholesaleActive || wholesaleHasMoq;
    const qbContainer = document.getElementById('bundler-discount-table');
    if (qbContainer) {
      const matchedQb = findBundleForVariant(qb, productId, variantId);
      if (matchedQb && showQb) {
        let qbHTML = '';
        if (wholesaleHasMoq) {
          qbHTML += '<p class="text-primary" style="font-weight: 600; margin-bottom: 0.5rem;">Non-Wholesale Pricing:</p>';
        }
        qbHTML += buildTableHTML(matchedQb.volume_discounts, price);
        qbContainer.innerHTML = qbHTML;
      } else {
        qbContainer.innerHTML = '';
      }
    }

    window.__bundlerDiscountData = { qb, wholesale, productId };
  }

  function renderRCA() {
    const customerTags = getCustomerTags();

    document.querySelectorAll('[data-bundler-rca-product]').forEach(el => {
      const pid = el.dataset.bundlerRcaProduct;
      const bundles = findBundlesForProduct(pid);
      const { qb, wholesale } = categorizeBundles(bundles, customerTags);

      const card = el.closest('.rca-card');
      const productTitle = card?.querySelector('p')?.textContent || '';
      let suffix = '';
      if (productTitle.includes('Coaxial')) suffix = 'ft';
      else if (productTitle.includes('Pair')) suffix = 'pairs';

      let html = '';
      let wholesaleActive = false;
      let wholesaleHasMoq = false;

      if (wholesale.length > 0) {
        const best = wholesale[0];
        const priceEl = card?.querySelector('[data-rca-price]');
        const wholesaleTier = getWholesaleTier(best.volume_discounts);

        if (wholesaleTier) {
          wholesaleActive = true;
          const moq = wholesaleTier.min_items;
          wholesaleHasMoq = moq > 1;

          if (priceEl) {
            const rawPrice = Number(priceEl.dataset.rcaPrice);
            if (rawPrice > 0) {
              const pct = Number(wholesaleTier.discount_value);
              const wholesalePrice = applyDiscount(rawPrice, pct);
              priceEl.innerHTML = `<span>${formatMoney(wholesalePrice)}</span> <span class="line-through">${formatMoney(rawPrice)}</span>`;
              priceEl.className = 'row gap-2';
            }
          }

          const moqText = wholesaleHasMoq ? `MOQ: ${moq}` : 'No MOQ';
          html += `<p>Wholesale Price (${moqText})</p>`;
        }
      }

      const showQb = !wholesaleActive || wholesaleHasMoq;
      if (showQb && qb.length > 0) {
        if (wholesaleHasMoq) {
          html += '<p style="font-weight: 600;">Non-Wholesale Pricing:</p>';
        }
        html += buildInlineDiscountText(qb[0].volume_discounts, suffix);
      }

      el.innerHTML = html;
    });
  }

  function updatePrices(price, variantId) {
    const data = window.__bundlerDiscountData;
    const vid = variantId || getSelectedVariantId();

    let wholesaleHasMoq = false;
    let wholesaleActive = false;
    if (data && data.wholesale && data.wholesale.length > 0) {
      const best = findBundleForVariant(data.wholesale, data.productId, vid);
      const wsContainer = document.getElementById('bundler-wholesale');

      if (best) {
        wholesaleActive = true;
        updateWholesalePriceDisplay(price, best);

        if (wsContainer) {
          wsContainer.hidden = false;
          const wholesaleTier = getWholesaleTier(best.volume_discounts);
          const moq = wholesaleTier ? wholesaleTier.min_items : 0;
          wholesaleHasMoq = moq > 1;
          const moqText = wholesaleHasMoq ? `Minimum Order Quantity: ${moq}` : 'No Minimum Order Quantity';
          wsContainer.innerHTML = `<p class="text-secondary">Wholesale Price (${moqText})</p>`;
        }
      } else if (wsContainer) {
        wsContainer.hidden = true;
        wsContainer.innerHTML = '';
      }
    }

    const qbContainer = document.getElementById('bundler-discount-table');
    if (qbContainer && data && data.qb && data.qb.length > 0) {
      const showQb = !wholesaleActive || wholesaleHasMoq;
      const matchedQb = findBundleForVariant(data.qb, data.productId, vid);

      if (matchedQb && showQb) {
        let qbHTML = '';
        if (wholesaleHasMoq) {
          qbHTML += '<p class="text-primary" style="font-weight: 600; margin-bottom: 0.5rem;">Non-Wholesale Pricing:</p>';
        }
        qbHTML += buildTableHTML(matchedQb.volume_discounts, price);
        qbContainer.innerHTML = qbHTML;
      } else {
        qbContainer.innerHTML = '';
      }
    } else if (qbContainer) {
      qbContainer.innerHTML = '';
    }
  }

  function snapshotDOMCartItems() {
    const items = new Map();
    document.querySelectorAll('#cart-drawer .line-item[data-variant-id]').forEach(li => {
      const vid = li.dataset.variantId;
      if (!vid) return;
      const input = li.querySelector('input[type="number"][name="quantity"]');
      const qty = input ? Number(input.value) : 1;
      if (Number.isFinite(qty) && qty > 0) {
        items.set(vid, (items.get(vid) || 0) + qty);
      }
    });
    return items;
  }

  function cartItemsFromEventDetail(detail) {
    const cartObj = detail && detail.original_cart_object;
    if (!cartObj || !Array.isArray(cartObj.items)) return null;

    const items = new Map();
    cartObj.items.forEach(item => {
      const vid = String(item.variant_id || '');
      const qty = Number(item.quantity);
      if (vid && Number.isFinite(qty) && qty > 0) {
        items.set(vid, (items.get(vid) || 0) + qty);
      }
    });
    return items;
  }

  function itemMapsEqual(a, b) {
    if (!a || !b) return false;
    if (a.size !== b.size) return false;
    for (const [k, v] of a.entries()) {
      if (b.get(k) !== v) return false;
    }
    return true;
  }

  // Event detail tag we add when WE synthesize a bundler:total_cart_values event from fresh data.
  // Used to bypass staleness checks for our own fresh dispatches.
  const OUR_DISPATCH_MARKER = '__resonixFreshDispatch';

  function isBundlerEventStale(detail) {
    if (!detail) return false;
    if (detail[OUR_DISPATCH_MARKER]) return false;
    const eventItems = cartItemsFromEventDetail(detail);
    if (!eventItems) return false;
    const domItems = snapshotDOMCartItems();
    return !itemMapsEqual(eventItems, domItems);
  }

  // Shopify's /cart.js returns line_price with cart-level discount allocations baked in
  // (e.g. an order-level Rewards discount lowers each item's line_price proportionally).
  // Bundler's bundler:total_cart_values listener decorates every line item where
  // `line_price !== original_line_price`, which means it spuriously decorates non-bundler
  // items as soon as a cart-level discount is applied. Our clearCartDiscounts/
  // restoreLineItemPrices then resets that decoration, bundler decorates again, and the
  // MutationObserver feedback runs `cart.js?bundler-cart-call` on a tight loop.
  //
  // Bundler's own reduceCartItemPrice tags items it actually discounted with the
  // `original_line_price_adjusted` property (see bundler script ~line 15911). We use that
  // as a marker to leave bundler-discounted items alone while normalizing line_price ==
  // original_line_price for everything else, so bundler's decorator skips them entirely.
  function normalizeNonBundlerLinePrices(detail) {
    if (!detail) return;
    const discounted = detail.discounted_cart_object;
    if (!discounted || !Array.isArray(discounted.items)) return;
    for (const item of discounted.items) {
      if (!item || typeof item.line_price !== 'number') continue;
      if (typeof item.original_line_price !== 'number') continue;
      if (typeof item.original_line_price_adjusted !== 'undefined') continue;
      if (item.line_price !== item.original_line_price) {
        item.line_price = item.original_line_price;
      }
    }
  }

  function hasShopifyCartLevelDiscount(subtotalRow) {
    if (!subtotalRow) return false;
    let sib = subtotalRow.nextElementSibling;
    while (sib) {
      if (sib.hasAttribute('data-bundler-cart-savings') || sib.hasAttribute('data-cart-total-row')) break;
      if (sib.classList.contains('row') && sib.classList.contains('justify-between')) return true;
      sib = sib.nextElementSibling;
    }
    return false;
  }

  function snapshotCartLineItems() {
    document.querySelectorAll('#cart-drawer .line-item[data-variant-id]').forEach(li => {
      const info = li.querySelector('.column.gap-1');
      if (info && !info.querySelector('[class*="bndlr"]')) {
        li.dataset.bndlrOriginalInfoHtml = info.innerHTML;
      }
      const linePrice = li.querySelector('.line-item-inner > p');
      if (linePrice && !linePrice.querySelector('[class*="bndlr"]')) {
        li.dataset.bndlrOriginalLinePriceHtml = linePrice.innerHTML;
      }
    });
  }

  function restoreLineItemPrices() {
    document.querySelectorAll('#cart-drawer .line-item[data-variant-id]').forEach(li => {
      const info = li.querySelector('.column.gap-1');
      if (info && info.querySelector('[class*="bndlr"]') && li.dataset.bndlrOriginalInfoHtml) {
        info.innerHTML = li.dataset.bndlrOriginalInfoHtml;
      }
      const linePrice = li.querySelector('.line-item-inner > p');
      if (linePrice && linePrice.querySelector('[class*="bndlr"]') && li.dataset.bndlrOriginalLinePriceHtml) {
        linePrice.innerHTML = li.dataset.bndlrOriginalLinePriceHtml;
      }
    });
  }

  function updateCartDiscounts(detail) {
    if (!detail) return;
    const { discount_amount, total_amount_discounted } = detail;
    if (!discount_amount || discount_amount <= 0) return;

    tagWholesaleLineItems();
    updateSavingsLabel();

    requestAnimationFrame(() => {
      document.querySelectorAll('[data-cart-subtotal-row]').forEach(el => {
        setDisplay(el, '');
      });
      document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
        const original = Number(el.dataset.originalSubtotal || 0);
        if (original > 0) setText(el, formatMoney(original));
      });

      document.querySelectorAll('[data-bundler-cart-savings]').forEach(el => {
        const amountEl = el.querySelector('[data-bundler-savings-amount]');
        if (amountEl) setText(amountEl, '-' + formatMoney(discount_amount));
        setDisplay(el, '');
      });

      document.querySelectorAll('[data-cart-total-price]').forEach(el => {
        const shopifyTotal = Number(el.dataset.originalTotal || 0);
        const adjustedTotal = shopifyTotal > 0 ? shopifyTotal - discount_amount : total_amount_discounted;
        setText(el, formatMoney(adjustedTotal));
      });
    });
  }

  function getWholesaleVariantIds() {
    const customerTags = getCustomerTags();
    const bundles = window.bndlr?.getBundles?.() || [];
    const ids = new Set();

    for (const b of bundles) {
      if (b.status !== 'enabled') continue;
      if (b.is_quantity_break !== 'true' && b.is_volume_bundle !== 'true') continue;
      if (!b.volume_discounts || b.volume_discounts.length === 0) continue;
      if (!isWholesaleBundle(b)) continue;
      if (!customerHasTag(customerTags, b.limit_for_customer_tags)) continue;

      for (const pid of Object.keys(b.products || {})) {
        for (const vid of Object.keys(b.products[pid].variants || {})) {
          ids.add(vid);
        }
      }
    }

    return ids;
  }

  function tagWholesaleLineItems() {
    const wholesaleVariants = getWholesaleVariantIds();
    document.querySelectorAll('.line-item[data-variant-id]').forEach(el => {
      el.toggleAttribute('data-is-wholesale-discount', wholesaleVariants.has(el.dataset.variantId));
    });
  }

  function updateSavingsLabel() {
    const hasWholesale = !!document.querySelector('.line-item[data-is-wholesale-discount]');
    const label = hasWholesale ? 'Wholesale/Quantity Discount' : 'Quantity discount';
    document.querySelectorAll('[data-bundler-savings-label]').forEach(el => {
      setText(el, label);
    });
  }

  function disallowRemovalOfFreeRollerInBundle() {
    const ROLLER_ID = '9935736832279';
    const bundles = window.bndlr?.getBundles?.() || [];
    const cartVariants = new Set(
      Array.from(document.querySelectorAll('.line-item[data-variant-id]'))
        .map(el => el.dataset.variantId)
    );

    const rollerVariants = new Set();
    let protect = false;

    for (const b of bundles) {
      if (b.status !== 'enabled') continue;
      const roller = b.products?.[ROLLER_ID];
      if (!roller || Number(roller.discount_amount) <= 0) continue;

      for (const vid of Object.keys(roller.variants || {})) rollerVariants.add(vid);

      for (const pid of Object.keys(b.products)) {
        if (pid === ROLLER_ID) continue;
        if (Object.keys(b.products[pid].variants || {}).some(vid => cartVariants.has(vid))) {
          protect = true;
          break;
        }
      }
      if (protect) break;
    }

    document.querySelectorAll('.line-item[data-variant-id]').forEach(el => {
      el.toggleAttribute('data-bundle-protected', protect && rollerVariants.has(el.dataset.variantId));
    });
  }

  function clearCartDiscounts() {
    document.querySelectorAll('[data-bundler-cart-savings]').forEach(el => {
      const amountEl = el.querySelector('[data-bundler-savings-amount]');
      if (amountEl) setText(amountEl, '');
      setDisplay(el, 'none');
    });

    document.querySelectorAll('[data-cart-total-price]').forEach(el => {
      const original = Number(el.dataset.originalTotal);
      if (Number.isFinite(original) && original >= 0) {
        setText(el, formatMoney(original));
      }
    });

    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      const original = Number(el.dataset.originalSubtotal);
      if (Number.isFinite(original) && original >= 0) {
        setText(el, formatMoney(original));
      }
    });

    document.querySelectorAll('[data-cart-subtotal-row]').forEach(row => {
      setDisplay(row, hasShopifyCartLevelDiscount(row) ? '' : 'none');
    });

    restoreLineItemPrices();
  }

  let clearDiscountsTimer = 0;
  function cancelPendingDiscountClear() {
    if (clearDiscountsTimer) {
      clearTimeout(clearDiscountsTimer);
      clearDiscountsTimer = 0;
    }
  }

  function scheduleDiscountClear() {
    cancelPendingDiscountClear();
    clearDiscountsTimer = setTimeout(() => {
      clearDiscountsTimer = 0;
      clearCartDiscounts();
    }, 100);
  }

  async function fetchFreshCart() {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      const res = await fetch(`/cart.js?currency=${encodeURIComponent(currency)}`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function dispatchBundlerEventWithCart(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return false;
    if (!window.bndlr || typeof window.bndlr.updateCartWithDiscounts !== 'function') return false;

    const dataItems = cartItemsFromEventDetail({ original_cart_object: cartData });
    if (dataItems && !itemMapsEqual(dataItems, snapshotDOMCartItems())) return false;

    let updated;
    try {
      updated = window.bndlr.updateCartWithDiscounts(JSON.parse(JSON.stringify(cartData)));
    } catch (e) {
      return false;
    }
    if (!updated) return false;

    updated[OUR_DISPATCH_MARKER] = true;
    document.dispatchEvent(new CustomEvent('bundler:total_cart_values', { detail: updated }));
    return true;
  }

  async function dispatchFreshBundlerEvent() {
    const cartData = await fetchFreshCart();
    if (cartData) dispatchBundlerEventWithCart(cartData);
  }

  function runBundlerCartSync(cartData) {
    snapshotCartLineItems();

    const dispatched = cartData ? dispatchBundlerEventWithCart(cartData) : false;
    if (!dispatched) dispatchFreshBundlerEvent();
  }

  // Bundler's cart.get() caches /cart.js responses for ~1.5s, which causes its debounced
  // updateCartDiscounts() and cart-drawer MutationObserver to re-dispatch stale events
  // after we've already updated the cart. Bundler's listener (added during its async init)
  // synchronously injects discount prices into our line items based on those stale events.
  //
  // We can't reliably register a capture-phase listener before bundler's listener (its registration
  // timing is non-deterministic), so we intercept document.dispatchEvent itself. Stale events are
  // suppressed at the source - no listener (ours or bundler's) ever sees them.
  const origDispatchEvent = document.dispatchEvent.bind(document);
  function patchedDispatchEvent(event) {
    if (event && event.type === 'bundler:total_cart_values') {
      let stale = false;
      try { stale = isBundlerEventStale(event.detail); } catch (e) { /* fall through */ }
      if (stale) return true;
      try { normalizeNonBundlerLinePrices(event.detail); } catch (e) { /* swallow */ }
    }
    return origDispatchEvent(event);
  }
  Object.defineProperty(document, 'dispatchEvent', {
    value: patchedDispatchEvent,
    writable: true,
    configurable: true,
  });

  document.addEventListener('bundler:total_cart_values', (e) => {
    if (e.detail && e.detail.discount_amount > 0) {
      cancelPendingDiscountClear();
      updateCartDiscounts(e.detail);
    } else {
      scheduleDiscountClear();
    }
    disallowRemovalOfFreeRollerInBundle();
  });

  window.__snapshotCartLineItems = snapshotCartLineItems;
  window.__runBundlerCartSync = runBundlerCartSync;
  snapshotCartLineItems();

  function init() {
    renderPDP();
    renderRCA();
    tagWholesaleLineItems();
    disallowRemovalOfFreeRollerInBundle();
  }

  if (window.bndlr && typeof window.bndlr.getBundles === 'function') {
    init();
  } else {
    document.addEventListener('bundler:loaded', init);
  }

  window.__bundlerUpdatePrices = function(price, variantId) { updatePrices(price, variantId); };
})();
